import { skipToken } from "@tanstack/react-query";
import { trpc } from "../../main/components/trpc.ts";
import useOwner from "./useOwner.ts";

export default () => {
  const owner = useOwner();
  const { data: allUsers } = trpc.user.getAllUsersLimited.useQuery(
    owner ? undefined : skipToken,
    {}
  );
  return allUsers || [];
};
